(function () {
  var moveElement = function (className, anchorElementClass) {
    var element = document.querySelector(className);
    var anchorElements = document.querySelectorAll(anchorElementClass);
    for (var i = 0; i < anchorElements.length; i++) {
      anchorElement = anchorElements[i];
      if (element) {
        var cloned = element.cloneNode(true);
        anchorElement.parentNode.insertBefore(cloned, anchorElement);
      }
    }
  };
  window.addEventListener('gift:hero:builder.initialized', function () {
    moveElement('.sc-builder > h1', '.sc-configurator > form, .sc-gift-card__container');
  });
})();